import AddIcon from "@mui/icons-material/Add";
import { Box, Stack } from "@mui/material";
import Breadcrumb from "components/Atoms/SharedComponents/Breadcrumbs/Breadcrumb";
import CCrud from "components/Molecules/Crud";
import ProductDetailsPage from "pages/products/productsDetails";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import { initialValues, structure, validationSchema } from "./structure";

const ProductsTemplate = ({
  handlePageChange,
  data,
  details,
  count,
  handelSubmit,
  deleteFun,
  filterList,
  actionsList,
  breadcrumbs,
  setFilterObj,
  rowData,
  paginationPage,
  headerChildren,
  modalComponents,
  openDeleteModal,
  setOpenDeleteModal,
  handleDeleteRequest,
  options,
  can_create,
  userType,
  load,
  isStore,
  isEventService = false,
  basePath = "/products",
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const [supportedLang, setSupportedLang] = useState("en");
  let columnData = [
    { accessor: "id", Header: "#" },
    {
      accessor: "nameEN",
      Header: t("products.col_name_en"),
      sort: true,
    },
    {
      accessor: "nameAR",
      Header: t("products.col_name_ar"),
      sort: true,
    },
    !isEventService && {
      accessor: "vendor",
      Header: t("products.col_vendor"),
      sort: true,
    },
    !isEventService && {
      accessor: "brand",
      Header: t("products.col_brand"),
      sort: true,
    },
    !isEventService && {
      accessor: "occasion",
      Header: t("products.col_occasion"),
      sort: true,
    },
    !isEventService && {
      accessor: "category",
      Header: t("products.col_category"),
      sort: true,
    },
    {
      accessor: "price",
      Header: t("products.col_price"),
      sort: true,
      width: 80,
    },
    {
      accessor: "price_after_discount",
      Header: t("products.col_price_after_discount"),
      sort: true,
    },
    !isEventService && {
      accessor: "total_on_hand",
      Header: t("products.col_quantity"),
      sort: true,
    },
    !isEventService && {
      accessor: "rate",
      Header: t("products.col_rate"),
      sort: true,
    },
    !isEventService && {
      accessor: "display_priority",
      Header: t("products.display_priority") || "Priority",
      sort: true,
    },
    !isEventService && {
      accessor: "is_featured",
      Header: t("products.is_featured") || "App Featured",
      sort: true,
    },
    !isEventService && {
      accessor: "featured_product_priority",
      Header: t("products.featured_product_priority") || "App Priority",
      sort: true,
    },
    !isEventService && {
      accessor: "featured_in_store",
      Header: t("products.featured_in_store") || "Store Featured",
      sort: true,
    },
    !isEventService && {
      accessor: "featured_store_priority",
      Header: t("products.featured_store_priority") || "Store Priority",
      sort: true,
    },
    !isEventService && {
      accessor: "featured_category_priority",
      Header: t("products.featured_category_priority") || "Category Priority",
      sort: true,
    },
    !isEventService && {
      accessor: "featured_occasion_priority",
      Header: t("products.featured_occasion_priority") || "Occasion Priority",
      sort: true,
    },
    { accessor: "toggle_status", Header: t("products.col_toggle_status") },
    { accessor: "status", Header: t("products.col_status") },
    !isEventService && {
      accessor: "approval_status",
      Header: t("products.col_approval_status"),
    },
    { accessor: "Actions", Header: t("products.col_actions") },
  ].filter(Boolean);
  const storeData = [
    { accessor: "id", Header: "#" },
    {
      accessor: "nameEN",
      Header: "Name(EN)",
      sort: true,
    },
    {
      accessor: "nameAR",
      Header: "Name(AR)",
      sort: true,
    },
    { accessor: "occasion", Header: "Occasion", sort: true },
    { accessor: "category", Header: "Category", sort: true },
    { accessor: "price", Header: "Price", sort: true, width: 80 },
    {
      accessor: "price_after_discount",
      Header: "Price after discount",
      sort: true,
    },
    { accessor: "total_on_hand", Header: "Quantity", sort: true },
    {
      accessor: "rate",
      Header: "Avg rate/Reviews count",
      sort: true,
    },
    {
      accessor: "display_priority",
      Header: t("products.display_priority") || "Priority",
      sort: true,
    },
    {
      accessor: "is_featured",
      Header: t("products.is_featured") || "App Featured",
      sort: true,
    },
    {
      accessor: "featured_product_priority",
      Header: t("products.featured_product_priority") || "App Priority",
      sort: true,
    },
    {
      accessor: "featured_in_store",
      Header: t("products.featured_in_store") || "Store Featured",
      sort: true,
    },
    {
      accessor: "featured_store_priority",
      Header: t("products.featured_store_priority") || "Store Priority",
      sort: true,
    },
    {
      accessor: "featured_category_priority",
      Header: t("products.featured_category_priority") || "Category Priority",
      sort: true,
    },
    {
      accessor: "featured_occasion_priority",
      Header: t("products.featured_occasion_priority") || "Occasion Priority",
      sort: true,
    },
    { accessor: "status", Header: "Status" },
    { accessor: "toggle_status", Header: "Toggle" },
    { accessor: "approval_status", Header: "Approval Status" },
    { accessor: "Actions", Header: "Actions" },
  ];

  if (isStore && !isEventService) {
    columnData = columnData.filter((col) => col.accessor !== "vendor");
  }
  return (
    <>
      <Box>
        <Stack
          direction="row"
          alignSelf="start"
          justifyContent="start"
          gap={2}
          width="100%"
          // mb={1}
        >
          <Breadcrumb data={breadcrumbs} />
        </Stack>
        <CCrud
          table={{
            list: data,
            listTitle: isEventService
              ? t("events_services.list_title")
              : t("products.breadcrumb_products"),
            createBtnTitle:
              can_create &&
              (isEventService
                ? t("events_services.add")
                : t("products.action_add_product")),
            CreateBtnIcon: AddIcon,
            createBtnFun: () => navigate("?type=form"),
            columns: columnData,
            isSearch: true,
            searchInputPlaceholder: isEventService
              ? t("events_services.search_placeholder")
              : t("products.placeholder_search"),
            isChecked: false,
            total_count: count,
            setFilterObj,
            paginationPage: paginationPage,
            handlePageChange,
            rowData: rowData,
            filterList,
            className: "main-table",
            actionsList, //if you want to add custom actions list
            headerChildren,
            details,
            openDeleteModal,
            setOpenDeleteModal,
            handleDeleteRequest,
          }}
          form={{
            initialValues: !id ? {} : initialValues(details, supportedLang),
            structure: (formik) =>
              structure(options, isStore, t, formik?.values, isEventService),
            validationSchema: (_) => validationSchema(t, isEventService),
            deleteFun: deleteFun,
            title: id
              ? isEventService
                ? t("events_services.edit")
                : t("products.breadcrumb_edit_product")
              : isEventService
                ? t("events_services.add")
                : t("products.breadcrumb_add_product"),
            submitTitle: id
              ? isEventService
                ? t("events_services.action_update")
                : t("products.action_update")
              : isEventService
                ? t("events_services.add")
                : t("products.action_add_product"),
            onSubmit: handelSubmit,
            className: { form: "main-form", actionButton: "main-form-buttons" },
          }}
          DetailsComponent={
            <ProductDetailsPage
              details={details}
              setOpenDeleteModal={setOpenDeleteModal}
              isEventService={isEventService}
            />
          }
          //to send details component diff from the default
          modalComponents={modalComponents}
        />
      </Box>
    </>
  );
};

export default ProductsTemplate;
